import { EZoneCodes } from '@/_types';

export const getZoneCode = (zone: string): EZoneCodes | undefined => {
  const parts = zone.split('.');

  return parts[parts.length - 1] as EZoneCodes | undefined;
};
